export function nl2br(text) {
    return text.split('\n').flatMap((line, index) => [
        <span key={index + '-text'}>{line}</span>,
        <br key={index + '-br'} />
    ]);
}